<template>
    <div class="kpi-card">
        <header v-if="payload.title || payload.subtitle" class="card-head">
            <div v-if="payload.title" class="card-title">{{ payload.title }}</div>
            <div v-if="payload.subtitle" class="card-sub">{{ payload.subtitle }}</div>
        </header>

        <div class="tiles" :style="{ '--tiles': String(items.length) }">
            <div v-for="(item, idx) in items" :key="idx" class="tile">
                <div class="tile-label">{{ item.label }}</div>
                <div class="tile-value">{{ item.value }}</div>
                <div v-if="item.delta" class="tile-delta" :class="'tone-' + item.tone">
                    {{ item.delta }}
                </div>
                <div v-if="item.hint" class="tile-hint">{{ item.hint }}</div>
            </div>
        </div>

        <div v-if="payload.footer" class="footer">{{ payload.footer }}</div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    payload: { type: Object, required: true },
})

const items = computed(() => {
    const raw = Array.isArray(props.payload?.items) ? props.payload.items : []
    return raw
        .filter(item => item && (item.label || item.value))
        .map(item => {
            const delta = typeof item.delta === 'string' ? item.delta.trim() : ''
            let tone = item.tone
            if (!['pos', 'neg', 'neu'].includes(tone)) {
                tone = delta.startsWith('-') ? 'neg' : (delta.startsWith('+') ? 'pos' : 'neu')
            }
            return {
                label: item.label || '',
                value: item.value ?? '—',
                delta,
                tone,
                hint: typeof item.hint === 'string' ? item.hint.trim() : '',
            }
        })
})
</script>

<style scoped>
.kpi-card {
    margin: 12px 0;
}

.card-head {
    margin-bottom: 10px;
}

.card-title {
    font-size: 14px;
    font-weight: 700;
    color: #23282C;
    line-height: 1.3;
}

.card-sub {
    font-size: 11px;
    color: #888888;
    margin-top: 4px;
}

/*
    Плитки должны идти в один ряд как в шапке Excel-дашборда, но при 5-6
    метриках на узком экране ряд обязан переноситься — отсюда auto-fit,
    а не фиксированные колонки.
*/
.tiles {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 10px;
}

.tile {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 14px;
}

.tile-label {
    font-size: 11px;
    color: #5f5f5f;
    margin-bottom: 6px;
}

.tile-value {
    font-size: 22px;
    font-weight: 600;
    color: #23282C;
    font-variant-numeric: tabular-nums;
    line-height: 1.2;
}

.tile-delta {
    font-size: 11px;
    font-weight: 600;
    margin-top: 3px;
    font-variant-numeric: tabular-nums;
}

.tile-hint {
    font-size: 10.5px;
    color: #888888;
    margin-top: 6px;
    line-height: 1.4;
}

.tone-pos { color: #0F6E56; }
.tone-neg { color: #E30613; }
.tone-neu { color: #888888; }

.footer {
    font-size: 10.5px;
    color: #888888;
    margin-top: 10px;
}

@media (max-width: 600px) {
    .tiles {
        grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
    }
    .tile-value { font-size: 18px; }
}
</style>
